<template>
  <section :data-e2e="dataE2e">
    <DropdownView
      :position="computedPosition"
      :triggers="[trigger]"
      @active-change="onActiveChange"
      :disabled="disabled"
      :can-close="canClose"
      :append-to-body="appendToBody"
      :mobile-modal="mobileModal"
      ref="dropdown"
    >
      <template #trigger>
        <slot name="trigger" />
      </template>
      <section v-if="isActive">
        <slot name="content" />
      </section>
    </DropdownView>
  </section>
</template>

<script>
import DropdownView from '@/modules/core/ui/components/wrappers/DropdownView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'Popover',
  emits: ['on-active', 'on-active-change'],
  slotsDefinition: {
    trigger: {},
    content: {}
  },
  components: {
    DropdownView
  },
  props: {
    appendToBody: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      validator(value) {
        return ['is-top-right', 'is-top-left', 'is-bottom-left', 'is-bottom-right'].includes(value);
      },
      default: 'is-bottom-right'
    },
    useFixedPositions: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canClose: {
      type: Boolean,
      default: true
    },
    dataE2e: {
      type: String,
      default: null
    },
    trigger: {
      type: String,
      validator(value) {
        return ['click', 'hover'].includes(value);
      },
      default: 'click'
    },
    mobileModal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isActive: false,
      computedPosition: this.position
    };
  },
  methods: {
    onActiveChange(value) {
      this.isActive = value;
      if (this.isActive) {
        this.positionDropdownMenu();
        this.$emit('on-active', value);
      }
      this.$emit('on-active-change', value);
    },
    toggle() {
      this.$refs.dropdown.toggle();
    },
    isShowing() {
      return this.isActive;
    },
    positionDropdownMenu() {
      if (this.useFixedPositions) {
        return;
      }

      const triggerRect = this.$el.getBoundingClientRect();
      const xDirection = this.position.split('-')[2];
      this.computedPosition =
        triggerRect.y + triggerRect.height + 200 > window.innerHeight
          ? 'is-top-' + xDirection
          : 'is-bottom-' + xDirection;
    }
  }
};
</script>

<style scoped>
section :deep(.dropdown .dropdown-menu),
:deep(.dropdown .dropdown-content) {
  max-width: initial !important;
  width: initial !important;
}
</style>
